import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Text from 'theme/components/Text.style';
import { SelectionDropdown } from 'shared/components/dropdown/SelectionDropdown';
import * as Section from 'settings/styles/SettingsSection.style';
import { InputMethodValue } from 'settings/utils/inputMethodStorage';

interface InputMethodProps {
  value: InputMethodValue;
  onChange: (value: InputMethodValue) => void | Promise<void>;
}

export default function InputMethod({
  value,
  onChange,
}: InputMethodProps): JSX.Element {
  const { t } = useTranslation('pageSettings');

  return (
    <>
      <Section.SectionHeader>
        <Text.H5>{t('inputMethod.title')}</Text.H5>
      </Section.SectionHeader>

      <Section.SectionCard>
        <Section.Rows>
          <Section.RowListItem $mobileColumn>
            <Section.RowLabel>
              <Text.P2Semibold>
                {t('inputMethod.setDefaultMethod')}
              </Text.P2Semibold>
            </Section.RowLabel>
            <Section.RowControl>
              <SelectionDropdown
                ariaLabel={t('inputMethod.setDefaultMethod')}
                value={value}
                options={[
                  { value: 'voice', label: t('inputMethod.voice') },
                  { value: 'keyboard', label: t('inputMethod.keyboard') },
                ]}
                onChange={(v) => onChange(v as InputMethodValue)}
              />
            </Section.RowControl>
          </Section.RowListItem>
        </Section.Rows>
      </Section.SectionCard>
    </>
  );
}
